import React, { useState, useEffect } from 'react'
import { EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../../Forms/fieldValidators'
import { Row, Col } from 'react-bootstrap'
import { Grid, Button, FormControlLabel, Dialog, Tooltip } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { COLORES } from '../../../../config/colores'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import moment from 'moment'
import {
  TABLA_CACHE_CUPOS_A_NOMINAR,
  TABLE_CUPOS_DISPONIBLES
} from '../../../../config/tables'
import { toast } from 'react-toastify'
import DialogoNominacionMultiple from '../DialogoNominacionMultiple'

const numeric0to100 = getNumericValidator(1, 100)

export function NominacionDeCuposMultiplesDialogView (props) {
  const { cargador, corredor, datosDeCupo, cantidadActual, submitCache,
    showNotificacion, showCloseNotificacion, isRequestingCupos } = props
  const [notificarCorredor, setNotificarCorredor] = useState(false)
  const [notificarCargador, setNotificarCargador] = useState(false)
  const [correoCargador, setCorreoCargador] = useState(null)
  const [correoCorredor, setCorreoCorredor] = useState(null)
  const [cantidad, setCantidad] = useState(0)
  const [cupoSeleccionado, setCupoSeleccionado] = useState([])

  useEffect(() => {
    const { cuposDisponibles, cuposCacheNominados } = props
    async function actualizarTablas () {
      if (cuposDisponibles && (cuposDisponibles.length === 0)) props.updateTablaDeCuposDisponibles()
      if (cuposCacheNominados && (cuposCacheNominados.length === 0)) props.updateTablaCacheDeCuposNominados()
    }
    actualizarTablas()
  }, [props])

  const handleNotificarCorredor = () => {
    if (notificarCorredor) {
      setNotificarCorredor(false)
      setCorreoCorredor(null)
      props.resetCorreoCorredor()
    } else {
      setNotificarCorredor(true)
      props.buscarCorreoCorredor(corredor).then((result) => {
        if (result) {
          setCorreoCorredor(result.correoElectronico)
        } else {
          setNotificarCorredor(false)
          props.resetCorreoCorredor()
        }
      })
    }
  }

  const handleNotificarCargador = async () => {
    if (notificarCargador) {
      setNotificarCargador(false)
      setCorreoCargador(null)
      props.resetCorreoCargador()
    } else {
      setNotificarCargador(true)
      props.buscarCorreoCargador(cargador).then((result) => {
        if (result) {
          setCorreoCargador(result.correoElectronico)
        } else {
          setNotificarCargador(false)
          props.resetCorreoCargador()
        }
      })
    }
  }

  const submitFormulario = async () => {
    await submitCache()
    setNotificarCargador(false)
    setCorreoCargador(null)
    props.resetCorreoCargador()
    setNotificarCorredor(false)
    setCorreoCorredor(null)
    props.resetCorreoCorredor()
    setCupoSeleccionado([])
  }

  const verificarCantidad = (value) => {
    console.log('cantidad', parseInt(value), cantidadActual)
    if (datosDeCupo) {
      props.actualizarCuposDisponibles(datosDeCupo, value)
      // datosDeCupo.cantidadDisponible
      if (cantidadActual < 0) {
        setCantidad(cantidadActual)
        toast.error('Compruebe que la cantidad a Nominar no supere la Cantidad disponible de cupos.', { autoClose: false })
      }
    } else {
      toast.info('Debe seleccionar un cupo disponible para Nominar.')
    }
  }

  const handleChange = (event) => {
    const {
      updateListaCuposSeleccionados
    } = props
    setCupoSeleccionado(event.target.value)
    updateListaCuposSeleccionados(event.target.value)
  }

  const handleClose = () => {
    showCloseNotificacion(props.roles, props.userName)
  }

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 350
      }
    }
  }

  moment.locale('ar-AR')

  return (
    <>
      <Dialog
        open={showNotificacion}
        onClose={handleClose}
      >
        <DialogoNominacionMultiple handleClose={handleClose} isRequestingCupos={isRequestingCupos} />
      </Dialog>

      <MuiTable id={TABLE_CUPOS_DISPONIBLES} />
      <hr />
      <Row>
        <Col md={5}>
          <EntityAutocomplete
            name='remitenteComercial'
            required
            label='Titular de Cupo *'
            entity='cargador'
            placeholder='Cargador - 19999999991'
          />
        </Col>
        <Col md={5}>
          <Tooltip title={'Eliminar bodega'}>
            <EntityAutocomplete
              name='corredorComprador'
              required
              label='Corredor de Cupo *'
              entity='corredor'
              placeholder='Corredor - 19999999991'
            />
          </Tooltip>
        </Col>
        <Col md={2}>
          <Field
            name='cantidadNominada'
            label='Cantidad *'
            type='number'
            component={renderTextField}
            validate={[required, numeric0to100]}
            placeholder=''
            value={cantidad}
            onChange={(e) => { verificarCantidad(e.target.value) }}
          />
        </Col>
        <Col md={12} style={{ textAlign: 'right', marginTop: '8px' }}>
          <p>(*) Campo requerido obligatorio</p>
        </Col>
      </Row>
      <div className='info-pie-dialogo' >
        <h6>
            Cereal:
          <span>
            {datosDeCupo && datosDeCupo.cereal}
          </span>
        </h6>
        <h6>
            Cantidad disponible:
          <span>
            {cantidadActual}
          </span>
        </h6>
        <h6>
            Fecha:
          <span>
            {datosDeCupo && datosDeCupo.fechaDeEmision}
          </span>
        </h6>
        {datosDeCupo &&
          <FormControl style={{ marginLeft: '3%', minWidth: 260, maxWidth: 500 }} >
            <InputLabel id='seleccion-label'>Seleccionar + fechas disponibles</InputLabel>
            <Select
              labelId='seleccion-label'
              id='cuposSeleccionados'
              multiple
              value={cupoSeleccionado}
              onChange={handleChange}
              input={<Input />}
              renderValue={
                (selected) => selected.map((cupito) =>
                  <Chip
                    display='flex'
                    flexwrap='wrap'
                    color='primary'
                    variant='outlined'
                    key={cupito.fechaDeAsignacion}
                    label={cupito.fechaDeEmision}
                  />
                )}
              MenuProps={MenuProps}
            >
              {props.cuposVigentesFiltrados.map((cupo) => (
                <MenuItem key={cupo.fechaDeAsignacion} value={cupo}>
                  <Checkbox checked={cupoSeleccionado.indexOf(cupo) > -1} />
                  <ListItemText primary={cupo.fechaDeEmision} secondary={cupo.exportador} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>}
      </div>
      <hr />
      <Row>
        <Col md={5}>
          {cargador && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCargador'
            onChange={handleNotificarCargador}
            checked={notificarCargador}
          />}label='Notificar al Titular de Cupo' />}
        </Col>
        <Col md={7}>
          {cargador && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCargador}
          </h6>}
        </Col>
      </Row>
      <Row>
        <Col md={5}>
          {corredor && <FormControlLabel style={{ marginLeft: '2%' }} control={<Switch
            color='primary'
            name='notificarCorredor'
            onChange={handleNotificarCorredor}
            checked={notificarCorredor}
          />}label='Notificar al Corredor de Cupo' />}
        </Col>
        <Col md={7}>
          {corredor && <h6 style={{ textAlign: 'left', marginTop: '8px', color: COLORES.grey.mediumDark }}>
            <MailOutlineIcon style={{ marginRight: '2%', color: COLORES.grey.mediumDark }} />
            {correoCorredor}
          </h6>}
        </Col>
      </Row>
      <Grid container justify='space-around'>
        <Button
          onClick={submitFormulario}
          type='button'
          size='medium'
          variant='contained'
          color='primary'
          disabled={!datosDeCupo || (cantidadActual < 0)}
        >Agregar
        </Button>
      </Grid>
      <MuiTable id={TABLA_CACHE_CUPOS_A_NOMINAR} />
    </>
  )
}
